import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class LiteraryCulturalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
